import React from 'react';

import { Label } from 'components/shared/Label';
import { getLabelColor } from 'components/shared/Label/utils';

import SubTitle from '../../../shared/SubTitle';
import s from '../../index.module.css';

function TripEvent({ block }: { block: any }) {
  return (
    <div className={s.subTitleWrapper}>
      <SubTitle text={block.data?.title} isAccent />
      {block.data?.badge && (
        <Label color={getLabelColor(block.data.badgeColor)} text={block.data.badge} className={s.label} />
      )}
    </div>
  );
}

export default TripEvent;
